import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DashboardCardsService } from "@app-service/dashboard-cards.service";
import { UserService } from "@app-service/user.service";

@Component({
    selector: "app-rupi-card-info",
    templateUrl: "./erupi-info.component.html",
    styleUrls: ["./erupi-info.component.scss"],
    standalone: false
})
export class ErupiInfoComponent implements OnInit {
  constructor(
    private router: Router,
    public userService: UserService,
    private dashboardCardsService: DashboardCardsService
  ) {}

  ngOnInit(): void {}

  onSettingUp(): void {
    this.dashboardCardsService.changeActiveDisplayTab("cards");
    this.router.navigate([`/erupi/admin`], {
      queryParams: { program: "e_rupi_voucher" },
    });
  }
}
